import { useEffect } from 'react';

interface UseRecordModalEffectsProps {
  queryRecordIdHandler(): void;
}

export const useRecordModalEffects = ({
  queryRecordIdHandler,
}: UseRecordModalEffectsProps) => {
  useEffect(() => {
    queryRecordIdHandler();
  }, [queryRecordIdHandler]);
};
